import React from 'react';
import * as PropTypes from 'prop-types';
import ConceptStatus from '../../containers/ConceptStatus';
import { Nav } from 'react-bootstrap';
import Tool from './Tool';

const Toolbar = ({ title, config, selected, selectItem }) => (
  <div className="d-flex flex-column sidebar-nav" role="complementary" aria-label={`${title} toolbar`}>
    <div className="flex-grow-0">
      <h1 className="title">{title}</h1>
    </div>
    <div className="flex-grow-1">
      <Nav className="flex-column">
        {config.map(
          (section) =>
            section.status !== 'hidden' && (
              <div key={section.id}>
                <li className="nav-header">{section.title}</li>
                {section.tools.map((tool) => (
                  <Tool
                    key={tool.url}
                    selectItem={selectItem}
                    selected={tool.url === selected}
                    {...tool}
                  />
                ))}
              </div>
            )
        )}
      </Nav>
    </div>
    <div className="box box-min">
      <ConceptStatus />
    </div>
  </div>
);
Toolbar.defaultProps = {
  title: '',
  config: [],
};
Toolbar.propTypes = {
  title: PropTypes.string,
  config: PropTypes.array,
  selectItem: PropTypes.func.isRequired,
};

export default Toolbar;
